import React, { memo } from 'react'

import { QRCodeSVG } from 'qrcode.react'

import { Box } from '@surglogs-app/ui'

import { getOtpAuthURL } from '../utils/generateOtpAuthUrl'

const QR_CODE_WIDTH = 163

export const MfaAuthenticatorAppQrCode = memo(
  ({ email, code }: { email: string; code: string }) => {
    return code ? (
      <Box
        {...{
          'data-intercom-id': 'mfa-authorization-qr-code',
          w: '180px',
          h: '180px',
          padding: 'sm',
          bgc: 'white.100',
          bd: '1px solid',
          bc: 'navy.25',
          bra: 'sm',
        }}>
        <QRCodeSVG
          {...{
            value: getOtpAuthURL(email, code),
            size: QR_CODE_WIDTH,
            'aria-label': 'Qr-code',
          }}
        />
      </Box>
    ) : null
  },
)
